import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsUsersByCountryQuery } from "../graphql/queries";
import type {
  AnalyticsUsersByCountryQueryType,
  AnalyticsUsersByCountryQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsUsersByCountryQuery = (
  options?: QueryHookOptions<
    AnalyticsUsersByCountryQueryType,
    AnalyticsUsersByCountryQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsUsersByCountryQueryType,
    AnalyticsUsersByCountryQueryVariablesType
  >(AnalyticsUsersByCountryQuery, options);
};
